import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from '../../../material.module';
import dayjs from 'dayjs/esm';

@Component({
    selector: 'app-date-range-picker',
    templateUrl: './date-range-picker.component.html',
    styleUrls: ['./date-range-picker.component.scss'],
    standalone: true,
    imports: [AngularMaterialModule, FormsModule, ReactiveFormsModule],
})
export class DateRangePickerComponent {
    @Input() selected: any;
    @Input() locale = {
        customRangeLabel: 'Pick a range',
        applyLabel: 'Apply Filter',
        clearLabel: 'Clear Filter',
        format: 'DD/MM/YYYY',
        daysOfWeek: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
        monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        firstDay: 1,
    };
    @Input() placeholder = 'Date Range';
    @Input() ranges: any = {
        Today: [dayjs(), dayjs()],
        Yesterday: [dayjs().subtract(1, 'days'), dayjs().subtract(1, 'days')],
        'Last 7 Days': [dayjs().subtract(6, 'days'), dayjs()],
        'Last 30 Days': [dayjs().subtract(29, 'days'), dayjs()],
        'This Month': [dayjs().startOf('month'), dayjs().endOf('month')],
        'Last Month': [dayjs().subtract(1, 'month').startOf('month'), dayjs().subtract(1, 'month').endOf('month')],
        'Last 3 Month': [dayjs().subtract(3, 'month').startOf('month'), dayjs().subtract(1, 'month').endOf('month')],
    };
    @Output() dateChange = new EventEmitter<any>();
    maxDate = dayjs();
    isDateFilterApplied = false;

    onDateChange(event: any) {
        this.isDateFilterApplied = !!(event?.startDate && event?.endDate);
        this.dateChange.emit(event);
    }

    clearDateFilter() {
        this.isDateFilterApplied = false;
        this.dateChange.emit(null);
    }
}
